// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1774":"dashboard-users","5090":"artist-verification","5177":"home","7708":"artist","8408":"song","9985":"album"}[chunkId] + "." + {"1774":"e7f7321f","5090":"e7f7321f","5177":"9b59e89d","7708":"9b59e89d","8408":"9b59e89d","9985":"9b59e89d"}[chunkId] + ".chunk.css";
};